import React, { Component } from 'react';
import { l10n } from '../../../i18n/Localization';
import Sc2Character from '../../../models/characters/Sc2Character';

class VerifySc2CharacterView extends Component {
    constructor(props) {
        super(props);

        this.cachedSc2Character = Sc2Character.deserialize(Sc2Character.serialize(props.sc2Character));
    }

    render() {
        return (
            <div>
                <div>{l10n.verifySc2CharacterView.profileUrl}: {this.cachedSc2Character.profileUrl}</div>
            </div>
        );
    }
}

export default VerifySc2CharacterView;
